import { getDay } from 'date-fns'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PreferredPaymentDayStatus, Weekday } from '../../model'
import { startCheckout, updatePreferredPayday } from '..'
import { getDayNumberFromUppercaseDay } from '../../utils/calendar'

export interface PreferredPaymentDayState {
  selectedPreferredDay: Weekday
  preferredPaymentDayStatus: PreferredPaymentDayStatus
}

export const preferredPaymentDayInitialState: PreferredPaymentDayState = {
  selectedPreferredDay: 1,
  preferredPaymentDayStatus: PreferredPaymentDayStatus.Pristine,
}

const slice = createSlice({
  name: 'preferredPaymentDay',
  initialState: preferredPaymentDayInitialState,
  reducers: {
    setPreferredPaymentDayAndStatus(state: PreferredPaymentDayState, action: PayloadAction<{ status: PreferredPaymentDayStatus; paymentDay: Weekday }>) {
      state.selectedPreferredDay = action.payload.paymentDay
      state.preferredPaymentDayStatus = action.payload.status
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(startCheckout.matchFulfilled, (state, action) => {
        if (state.preferredPaymentDayStatus === PreferredPaymentDayStatus.Pristine) {
          state.selectedPreferredDay = getDay(new Date(action.payload.paymentSchedules[0]?.installmentDueDate ?? new Date())) as Weekday
        }
      })
      .addMatcher(updatePreferredPayday.matchFulfilled, (state, action) => {
        state.preferredPaymentDayStatus = PreferredPaymentDayStatus.ManuallySet
        state.selectedPreferredDay = getDayNumberFromUppercaseDay(action.meta.arg.originalArgs.preferredPaymentDay)
      })
  },
})

export const { setPreferredPaymentDayAndStatus } = slice.actions

export default slice.reducer
